
import { NoseurObject } from "@rivtn/noseur";
import { Actor, SanitizedResponse } from "../BaseService";
import { ConfigurationType, PloutousBaseService } from "./PloutousBaseService";
import { ICountry } from "./CountryService";

export interface ICountryConfiguration {
    key: any;
    options?: any;
    status: string;
    created_by: Actor;
    updated_by: Actor;
    created_at: string;
    updated_at: string;
    description: string;
    external_id: string;
    type: ConfigurationType;
}

export interface ICountryConfigurationMapping {
    value: any;
    country: ICountry;
    created_by: Actor;
    updated_by: Actor;
    created_at: string;
    updated_at: string;
    external_id: string;
    type: ConfigurationType;
    country_configuration: ICountryConfiguration;
}

export class CountryConfigurationAndMappingService extends PloutousBaseService {

    protected static instance: CountryConfigurationAndMappingService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!CountryConfigurationAndMappingService.instance) CountryConfigurationAndMappingService.instance = new CountryConfigurationAndMappingService();
        return CountryConfigurationAndMappingService.instance;
    }

    queryCountryConfigurations(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ICountryConfiguration>> {
        return this.report(this.transport.get("/api/v1/country/configuration", { query: this.normalizeParams(params) }));
    }

    createCountryConfiguration(payload: any): Promise<SanitizedResponse<ICountryConfiguration>> {
        return this.report(this.transport.post(`/api/v1/country/configuration`, payload));
    }

    updateCountryConfiguration(payload: Partial<ICountryConfiguration>): Promise<SanitizedResponse<ICountryConfiguration>> {
        const id = payload.external_id; delete payload.external_id;
        return this.report(this.transport.patch(`/api/v1/country/configuration/${id}`, payload));
    }

    deleteCountryConfiguration(id: string): Promise<SanitizedResponse<ICountryConfiguration>> {
        return this.report(this.transport.delete(`/api/v1/country/configuration/${id}`));
    }

    queryCountryConfigurationMappings(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<SanitizedResponse<ICountryConfigurationMapping>> {
        return this.report(this.transport.get("/api/v1/country/configuration/mapping", { query: this.normalizeParams(params) }));
    }

    createCountryConfigurationMapping(payload: any): Promise<SanitizedResponse<ICountryConfigurationMapping>> {
        return this.report(this.transport.post(`/api/v1/country/configuration/mapping`, payload));
    }

    updateCountryConfigurationMapping(payload: Partial<ICountryConfigurationMapping>): Promise<SanitizedResponse<ICountryConfigurationMapping>> {
        const id = payload.external_id; delete payload.external_id;
        return this.report(this.transport.patch(`/api/v1/country/configuration/mapping/${id}`, payload));
    }

    deleteCountryConfigurationMapping(id: string): Promise<SanitizedResponse<ICountryConfigurationMapping>> {
        return this.report(this.transport.delete(`/api/v1/country/configuration/mapping/${id}`));
    }

}
